import XTbl,{Xtc} from '../../components/x-table/index'
const tbl = new XTbl('/calendar/query/', 'Events')

tbl.add(new Xtc('title', 'Title').renderSlot('title'))
tbl.add(new Xtc('creator', 'Creator').renderSlot('creator'))
// tbl.add(new Xtc('is_all_day', 'All Day').renderSlot('is_all_day'))
tbl.add(new Xtc('is_for_firm', 'Firm Event').hidden().renderSlot('is_for_firm'))
tbl.add(new Xtc('labels', 'Priority').renderSlot('labels'))
tbl.add(new Xtc('start', 'Start date').renderSlot('start'))
tbl.add(new Xtc('end', 'End date').renderSlot('end'))
tbl.add(new Xtc('tags', 'Tags').hidden().renderSlot('tags'))
tbl.add(new Xtc('', 'Attendees').renderSlot('attendees'))
tbl.add(new Xtc('matter', 'Matter').renderSlot('matter'))
tbl.add(new Xtc('description', 'Description').renderSlot('description'))
tbl.add(new Xtc('location', 'Location').hidden())
tbl.add(new Xtc('action', 'Action').noSort().renderSlot('action'))

export default tbl

// The data in case we want to display repeats as well.
//     "repeat_type": -1,
//     "repeat_every": 0,
//     "in_repeat_weekly_repeat_on_monday": false,
//     "in_repeat_weekly_repeat_on_tuesday": false,
//     "in_repeat_weekly_repeat_on_wednesday": false,
//     "in_repeat_weekly_repeat_on_thursday": false,
//     "in_repeat_weekly_repeat_on_friday": false,
//     "in_repeat_weekly_repeat_on_saturday": false,
//     "in_repeat_weekly_repeat_on_sunday": false,
//     "in_repeat_monthly_repeat_on_day_of_month": null,
//     "repeat_end_date": null,
//     "repeat_end_after_occurrence": null,
//     "repeat_occurrence_notification_count": 0,
